import { type Column } from '@tanstack/react-table';

export const getStickyCellStyles = (
  column: Column<unknown, unknown>,
): React.CSSProperties =>
  ({
    position: column?.getIsPinned() ? 'sticky' : 'relative',
    width: column?.getSize(),
    left:
      column?.getIsPinned() === 'left'
        ? `${column?.getStart('left')}px`
        : undefined,
    right:
      column?.getIsPinned() === 'right'
        ? `${column?.getAfter('right')}px`
        : undefined,
  }) as const;

export const getPinnedEdgeDataAttribute = (
  column?: Column<unknown, unknown>,
) => {
  if (column?.getIsLastColumn('left')) {
    return 'left';
  }
  if (column?.getIsFirstColumn('right')) {
    return 'right';
  }
  return false;
};

export const getPinnedDataAttribute = (column?: Column<unknown, unknown>) => {
  return !!column?.getIsPinned();
};

export const getPinnedSideDataAttribute = (
  column?: Column<unknown, unknown>,
) => {
  return column?.getIsPinned() || false;
};
